/**
 * API base URL for dashboard and app fetches.
 * - Dev: use CRA proxy (empty string = same origin) or REACT_APP_API_URL
 * - Production: same origin when API is served with the app
 */

export function getApiBase() {
  const explicit = (process.env.REACT_APP_API_URL || '').trim().replace(/\/$/, '');
  if (explicit) return explicit;
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }
  return '';
}
